module.exports = __webpack_public_path__ + "img/h2.218bb24b.png";